/**
 * Money formatting for the trade-in reward display. The redesign shows clean figures with a
 * trailing currency word, e.g. "360 kr" (serif, tabular) — matching the mockup's
 * `n.toLocaleString("da-DK")` + " kr". Cents are dropped since trade-in offers are whole units.
 */

/** Number part only, grouped for da-DK (e.g. 1234 → "1.234"). Use with `currencySuffix`. */
export function money(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString('da-DK', { maximumFractionDigits: 0 })
}

/** Short currency word shown after the amount. DKK renders as the Danish "kr". */
export function currencySuffix(currency?: string | null): string {
  if (!currency || currency === 'DKK') return 'kr'
  if (currency === 'EUR') return '€'
  return currency
}

/** Convenience: "360 kr". */
export function formatMoney(value: number | null | undefined, currency?: string | null): string {
  return `${money(value)} ${currencySuffix(currency)}`
}
